<template>
  <div class="">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="运单编号:" class="item1">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNo" ></el-input>
          </el-form-item>
          <el-form-item label="账单编号:" class="item1">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.zdh"></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="searchFrom.settlementStatesList" placeholder="请选择结算状态" multiple>
              <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票状态:">
            <el-select v-model="searchFrom.invoicingStates" placeholder="请选择开票状态">
              <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款方:">
            <el-input v-model="searchFrom.payee" placeholder="请输入收款方"></el-input>
          </el-form-item>
          <el-form-item label="业务部门:">
            <el-select v-model="searchFrom.businessSubunit" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建部门:">
            <el-select v-model="searchFrom.createSubdepartmentName" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称:"  >
            <el-select v-model="searchFrom.projectType" filterable placeholder="请选择">
              <el-option  label="全部" value="" ></el-option>
              <el-option v-for="item in xmList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
             <el-button type="primary" size="mini" :disabled="isDisable" v-if="btnFlg[7]" @click="ZDdaochuFN" >导出</el-button>
            <el-button type="primary" size="mini" @click="delSettlementFn" v-if="btnFlg[0]">撤销对账</el-button>
            <el-button type="primary" size="mini" @click="chexiaoShouKuan" v-if="btnFlg[1]">撤销付款</el-button>
            <el-button type="primary" size="mini" @click="chexiaoKaiPiao" v-if="btnFlg[2]">撤销开票</el-button>
            <el-button type="primary" size="mini" @click="allFuKuanFn" v-if="btnFlg[3]">一键付款</el-button>
            <el-button type="primary" size="mini" @click="allInvoiceFn" v-if="btnFlg[4]">一键开票</el-button>
          </el-form-item>
          <el-form-item>
            <div style="display:flex;">
              <p style="width:15px;height:15px;background:#ffc7c1;margin-top: 6px;"></p>
              <span style="margin-left:5px;">超期未到票</span>
            </div>
          </el-form-item>
          <span>
            <el-form-item>
              <p class="margin0">支出合计:<span class="red">{{map.totalAmountSum}}</span>元</p>
            </el-form-item>
            <el-form-item label-width="120px">
              <p class="margin0">未付款金额合计:<span class="red">{{map.noPaymentAmount}}</span>元</p>
            </el-form-item>
            <el-form-item label-width="120px">
              <p class="margin0">已付款金额合计:<span class="red">{{map.paymentAmount}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">已选：未付款金额<span class="red">{{yixuanJson.wfkje|moneyFormatNew}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">未开票金额<span class="red">{{yixuanJson.wkpje|moneyFormatNew}}</span>元</p>
            </el-form-item>
          </span>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tableList" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" :cell-class-name="myclass" @selection-change='selectGoods'
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="150">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :disabled='scope.row.isDisable' @click="daochuFN(scope.row)">导出明细</el-button>
            <el-button type="text" size="mini" @click="YFZDdetils(scope.row)" v-if="scope.row.settlementStates < '2'&&(scope.row.auditStatus==3||scope.row.auditStatus=='0')&&btnFlg[8]">付款</el-button>
            <el-button type="text" size="mini" @click="YFZDdetils(scope.row)" v-if="scope.row.invoicingStates <'2'&&(scope.row.auditStatus==3||scope.row.auditStatus=='0')&&btnFlg[9]">开票</el-button>
            <el-button type="text" size="mini" @click="FKPZfn(scope.row)"  v-if="scope.row.paymentAnnotation != 1&&btnFlg[5]&&(scope.row.auditStatus==3||scope.row.auditStatus=='0')">付款批注</el-button>
            <el-button type="text" size="mini" @click="QXPZfn(scope.row)" v-if="scope.row.paymentAnnotation == 1&&btnFlg[6]&&(scope.row.auditStatus==3||scope.row.auditStatus=='0')">取消批注</el-button>
            <el-button type="text" size="mini" @click="shenheFn(scope.row)" v-if="scope.row.auditUserId == userCode">审核</el-button>
             <el-button type="text" size="mini" v-if="scope.row.settlementStates =='0'&&scope.row.invoicingStates=='0'&&btnFlg[10]&&(scope.row.auditStatus==3||scope.row.auditStatus=='0')" @click="bukaipiaoFN(scope.row)">不开票</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="billNo" label="账单号" width="200">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.auditStatus==3||scope.row.auditStatus=='0'" effect="dark" :content="scope.row.billNo" placement="right-end">
              <el-button type="text" @click="detilsYF(scope.row)">{{scope.row.billNo}}</el-button>
              <div slot="content" style="cursor: pointer;" @click="copyBtn(scope.row.billNo)">复制</div>
            </el-tooltip>
            <div v-else>******</div>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.auditStatus=='0'">不审核</span>
            <el-button type="text" v-else @click="SHXQfn(scope.row)">{{['不审核','待审核','审核中','审核通过','审核驳回'][scope.row.auditStatus]}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="结算状态" width="120">
          <template scope="scope">
            <span class="wsStyle" v-show="scope.row.settlementStates == '-1'">未对账</span>
            <span class="wsStyle" v-show="scope.row.settlementStates == '0'">未付款</span>
            <span class="bfStyle" v-show="scope.row.settlementStates == '1'">部分付款</span>
            <span class="ysStyle" v-show="scope.row.settlementStates == '2'">已付款</span>
             <span class="ysStyle" v-show="scope.row.settlementStates == '3'">不付款</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="开票状态" width="120">
          <template scope="scope">
            <!-- 0.未开票、1.部分开票、2.已开票 -->
            <span class="wsStyle" v-show="scope.row.invoicingStates == '0'">未开票</span>
            <span class="bfStyle" v-show="scope.row.invoicingStates == '1'">部分开票</span>
            <span class="ysStyle" v-show="scope.row.invoicingStates == '2'">已开票</span>
             <span class="ysStyle" v-show="scope.row.invoicingStates == '3'">不开票</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="付款批注" width="120">
          <template scope="scope">
            <!-- 0.未开票、1.部分开票、2.已开票 -->
            <span class="wsStyle" v-show="scope.row.paymentAnnotation  == '0'">未批注</span>
            <span class="bfStyle" v-show="scope.row.paymentAnnotation  == '1'">已批注</span>
          </template>
        </el-table-column>
        <el-table-column prop="payee" label="收款方" width="300">
        </el-table-column>
        <el-table-column prop="projectType" label="项目名称" width="160"> </el-table-column>
        <el-table-column prop="" label="到票期限(天)" width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.generalInvoiceDays== null">-</span>
              <span v-else>{{ scope.row.generalInvoiceDays }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="到票超期天数(天)" width="140">
          <template scope="scope">
            <div>
              <span v-if="scope.row.overdue">
                <span v-if="scope.row.overdue<=0">-</span>
                <span v-else class="wsStyle">{{ scope.row.overdue }}</span>
              </span>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="wayNumber" label="运单数量" width="90">
        </el-table-column>
        <el-table-column prop="totalAmount" label="支出合计(元)" width="140">
        </el-table-column>
        <el-table-column prop="paymentAmount" label="已付款金额(元)" width="130">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="getFuKuanFn(scope.row)">{{scope.row.paymentAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noPaymentAmount" label="未付款金额(元)" width="130">
        </el-table-column>
        <el-table-column prop="" label="已开票金额(元)" width="130">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="getYiKaiPiaoFn(scope.row)">{{scope.row.invoiceAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noInvoiceAmount" label="未开票金额(元)" width="130">
        </el-table-column>
        <el-table-column prop="businessSubunit" label="业务部门" width="130" show-overflow-tooltip  :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="createSubdepartmentName" label="创建部门" width="130" show-overflow-tooltip  :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="createUser"  label="创建人" width="170"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 审核 -->
    <el-dialog  title="审核" :close-on-click-modal="false" :close-on-press-escape="false"  @close="SHflag = false"  :visible.sync="SHflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="SHform" :model="SHform"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="审核原因" class="item1" prop="auditRemark"  :rules="SHform.auditStatus==4?rules.auditRemark:[{required: false}]" >
            <el-input placeholder="" type="textarea" maxlength="100" v-model.trim="SHform.auditRemark" class="gjh"></el-input>
          </el-form-item>
          <el-form-item prop="auditStatus" label="审核状态">
            <template>
              <el-radio v-model="SHform.auditStatus" label="3">通过</el-radio>
              <el-radio v-model="SHform.auditStatus" label="4">驳回</el-radio>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SHflag = false">取 消</el-button>
        <el-button type="primary" @click="SHsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审核记录 -->
    <el-dialog  title="审核记录" :close-on-click-modal="false" :close-on-press-escape="false"  @close="SHXQflag = false"  :visible.sync="SHXQflag" width="800px" center>
      <div>
         <el-table height="400px" size="mini" ref="tabref" :data="SHXQlist" style="width:100%"  border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
         <el-table-column prop="auditState" label="审核状态" width="100">
          <template slot-scope="scope">
            <span>{{['审核通过','审核驳回','待审核'][scope.row.auditState]}}</span>
          </template>
        </el-table-column>
          <el-table-column prop="auditRemark" :formatter="formatterRowEmpty" min-width="200" label="审核原因"></el-table-column>
          <el-table-column prop="auditUserName" min-width="120"  label="审核人"></el-table-column>
          <el-table-column prop="auditTime" min-width="170" :formatter="dateTimeFormat" label="审核时间"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SHXQflag = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 一键付款 -->
    <yiJianFuKuan v-if="fuKuanMark" :fuKuanMark.sync='fuKuanMark' :fuKuanFrom='fuKuanFrom' @refresh = 'getList' :detilsFlag = 'false'></yiJianFuKuan>
    <!-- 一键开票 -->
    <FuKuanKaiPiao v-if="kaiPiaoMark" :kaiPiaoMark.sync='kaiPiaoMark' :kaiPiaoFrom='kaiPiaoFrom' @refresh = 'getList' :detilsFlag = 'false'></FuKuanKaiPiao>
    <!-- 点击已付金额弹窗 -->
    <yiFujinE v-if="FKJLMark" :FKJLMark.sync='FKJLMark' :fuKuanJL='fuKuanJL' @refresh = 'getList'></yiFujinE>
    <!-- 点击已开票金额弹窗 -->
    <fuKuanYiKaiPiaojinE v-if="KPJLMark" :KPJLMark.sync='KPJLMark' :kaiPiaoJL='kaiPiaoJL' @refresh = 'getList'></fuKuanYiKaiPiaojinE>
    <!-- 点击账单号 -->
    <yingFuDetil v-if="yingFuDetilsMark" :yingFuDetilsMark.sync='yingFuDetilsMark'
      :yfSettlementBillId = 'yfSettlementBillId'></yingFuDetil>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getSettlementBillList, delSettlementBill, paymentAnnotation, revokePaymentAnnotation, getSettlementBillListTotal, tAuditRecordList,
  settlementBillAudit, getDictionaryDetailList, noInvoiceSettlementBill } from '@/api/newTMS'
import { getCurrUserDepartment } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat1, formatterRowEmpty, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import yiJianFuKuan from '@/views/newTMS/publicFiles/caiWuYingFu/yiJianFuKuan.vue'
import yiFujinE from '@/views/newTMS/publicFiles/caiWuYingFu/yiFujinE.vue'
import FuKuanKaiPiao from '@/views/newTMS/publicFiles/caiWuYingFu/FuKuanKaiPiao.vue'
import fuKuanYiKaiPiaojinE from '@/views/newTMS/publicFiles/caiWuYingFu/fuKuanYiKaiPiaojinE.vue'
import yingFuDetil from '@/views/newTMS/publicFiles/caiWuYingFu/yingFuDetil.vue'
export default {
  name: 'Freight',
  components: {
    yiJianFuKuan,
    yiFujinE,
    FuKuanKaiPiao,
    fuKuanYiKaiPiaojinE,
    yingFuDetil
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      formatterRowEmpty: formatterRowEmpty,
      loading: false,
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未付款',
          value: '0'
        },
        {
          showName: '部分付款',
          value: '1'
        },
        {
          showName: '已付款',
          value: '2'
        },
        {
          showName: '不付款',
          value: '3'
        }
      ],
      ysInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未开票',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        },
        {
          showName: '不开票',
          value: '3'
        }
      ],
      // 查询条件
      createTime: [],
      searchFrom: {
        insideOutsideType: 1,
        paymentFlag: 1,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00J0200', '01N00J0C00', '01N00J0300', '01N00J0400', '01N00J0500', '01N00J0E00', '01N00J0F00', '01N00J0H00', '01N00J0A00', '01N00J0B00', '01N00J0I00'],
      tableList: [],
      map: {
        totalAmountSum: 0
      },
      fuKuanMark: false,
      fuKuanFrom: {},
      fuKuanJL: {
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        settlementBillId: ''
      },
      FKJLMark: false,
      kaiPiaoMark: false,
      kaiPiaoFrom: {},
      KPJLMark: false,
      kaiPiaoJL: {
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        settlementBillId: ''
      },
      yingFuDetilsMark: false,
      yfSettlementBillId: '',
      bumenList: [],
      userCode: localStorage.getItem('userCode'),
      SHXQlist: [],
      SHXQflag: false,
      SHform: {},
      SHflag: false,
      rules: {
        auditStatus: [
          { required: true, message: '请选择审核状态', trigger: 'blur' }
        ],
        auditRemark: [
          { required: true, message: '请输入审核原因', trigger: 'blur' }
        ]

      },
      isDisable: false,
      xmList: [],
      yixuanJson: { wfkje: 0.00, wkpje: 0.00 }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yingFuSettlement')
    this.createTime = getLastMonth()
    getCurrUserDepartment().then(res => { this.bumenList = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.xmList = res })
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 200 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 不开票
    bukaipiaoFN (row) {
      this.$confirm('是否需要将该账单的结算状态设为“不付款”，开票状态设为“不开票”？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        noInvoiceSettlementBill({
          id: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {})
    },
    // 选择数据
    selectGoods (selection) {
      this.yixuanJson.wfkje = 0.00
      this.yixuanJson.wkpje = 0.00
      selection.forEach((item, index) => {
        this.yixuanJson.wfkje += item.noPaymentAmount
        this.yixuanJson.wkpje += item.noInvoiceAmount
      })
    },
    // 账单导出
    async ZDdaochuFN () {
      this.isDisable = true
      if (this.searchFrom.settlementStatesList && this.searchFrom.settlementStatesList.length == 0) {
        this.$set(this.searchFrom, 'settlementStatesList', null)
      }
      if (this.createTime) {
        if (this.createTime.length > 0) {
          this.$set(this.searchFrom, 'createTime', this.createTime)
        }
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.zdh) {
        let zdhArr = this.searchFrom.zdh.split(/\s+/)
          .map(v => v.trim())
          .filter(v => v)
        if (zdhArr.length == 1) {
          this.searchFrom.billNo = zdhArr[0]
        } else {
          this.searchFrom.billNos = zdhArr
        }
      } else {
        this.searchFrom.billNos = null
        this.searchFrom.billNo = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      await exportExcel(
        this.global.tmsPlus + '/settlementBill/exportSettlementBillList',
        form,
        '应付账单列表'
      )
      this.isDisable = false
    },
    // 审核
    shenheFn (row) {
      this.SHflag = true
      this.SHform = {}
      this.SHform.id = row.id
    },
    SHsaveFn () {
      this.$refs.SHform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          settlementBillAudit(this.SHform).then(res => {
            loading.close()
            this.SHflag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 审核详情
    SHXQfn (row) {
      tAuditRecordList({ businessType: 1, businessTableId: row.id }).then(res => {
        this.SHXQflag = true
        this.SHXQlist = res
        if (row.auditStatus == 2 || row.auditStatus == 1) {
          this.SHXQlist.unshift({ auditState: 2, auditUserName: row.auditUserName })
        }
      })
    },
    // 付款批注
    FKPZfn (row) {
      this.$confirm('是否付款批准?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        paymentAnnotation({ id: row.id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    QXPZfn (row) {
      this.$confirm('是否取消付款批准?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        revokePaymentAnnotation({ id: row.id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 复制
    copyBtn (message) {
      // navigator.clipboard.writeText 该方法需要在安全域下才能够使用，比如：https 协议的地址、127.0.0.1、localhost
      navigator.clipboard
        .writeText(message)
        .then(() => {
          this.$message.success('复制成功')
        }).catch((err) => {
        })
    },
    // 获取列表
    getList () {
      if (this.searchFrom.settlementStatesList && this.searchFrom.settlementStatesList.length == 0) {
        this.$set(this.searchFrom, 'settlementStatesList', null)
      }
      if (this.createTime) {
        if (this.createTime.length > 0) {
          this.$set(this.searchFrom, 'createTime', this.createTime)
        }
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.zdh) {
        let zdhArr = this.searchFrom.zdh.split(/\s+/)
          .map(v => v.trim())
          .filter(v => v)
        if (zdhArr.length == 1) {
          this.searchFrom.billNo = zdhArr[0]
        } else {
          this.searchFrom.billNos = zdhArr
        }
      } else {
        this.searchFrom.billNos = null
        this.searchFrom.billNo = ''
      }
      getSettlementBillList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        const timestamp = new Date().getTime()
        this.tableList.forEach(item => {
          if (item.invoicingStates == '0') {
            if (item.generalInvoiceDate) {
              if (item.generalInvoiceDate < timestamp) {
                let dateNum = Math.floor((timestamp - item.generalInvoiceDate) / (1000 * 60 * 60 * 24))
                console.log(dateNum, 'item.generalInvoiceDate - timestamp')
                this.$set(item, 'overdue', dateNum)
              }
            }
          }
        })
      })
      getSettlementBillListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 修改单元格样式的方法
    myclass ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '到票超期天数(天)') {
        if (row.overdue > 0) {
          return 'setclass'
        }
      }
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        insideOutsideType: 1,
        paymentFlag: 1,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTime = getLastMonth()
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 账单详情
    YFZDdetils (row) {
      this.$router.push({ name: 'YFZDdetils', query: { yfSettlementBillId: row.id, settlementPattern: row.settlementPattern, makeTicketYn: row.makeTicketYn, payer: row.payee } })
    },
    // 点击账单号
    detilsYF (row) {
      this.yingFuDetilsMark = true
      this.yfSettlementBillId = row.id
    },
    // 撤销对账
    delSettlementFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        // 未付款、未开票、不收款、不开票
        if ((selectData[0].settlementStates != 0 || selectData[0].invoicingStates != 0) && (selectData[0].settlementStates != 3 || selectData[0].invoicingStates != 3)) {
          this.$alert('只能选择未付款且未开票的账单撤销', '系统提示')
        } else {
          this.$confirm('是否执行操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            delSettlementBill({
              id: selectData[0].id
            }).then(res => {
              loading.close()
              this.$message({
                message: '撤销成功',
                type: 'success'
              })
              this.getList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {})
        }
      }
    },
    // 点击一键付款
    allFuKuanFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].auditStatus != 3 && selectData[0].auditStatus != '0') { // 审核通过或者不审核才能操作
          this.$alert('审核通过或不审核的账单才能操作', '系统提示')
          return
        }
        if (selectData[0].settlementStates == '2' || selectData[0].settlementStates == '3') {
          this.$alert('只能选择未付款或部分付款的数据', '系统提示')
          return
        }
        this.$set(this.fuKuanFrom, 'settlementBillId', selectData[0].id)
        this.$set(this.fuKuanFrom, 'recordType', 0)
        this.$set(this.fuKuanFrom, 'pendingAmount', selectData[0].totalAmount)
        this.$set(this.fuKuanFrom, 'collectionAmount', selectData[0].noPaymentAmount)
        this.fuKuanMark = true

        // 参数 以下都必填
        // settlementBillId 账单表主键id
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 收款金额（待收金额）
        // collectionAmount 收款金额（收款金额）
        // collectionTime 收款时间 日期类型
      }
    },
    // 点击已收款金额
    getFuKuanFn (row) {
      if (row.settlementStates == '0') {
        this.$alert('只能选择已付款或者部分付款的数据', '系统提示')
      } else {
        this.fuKuanJL.settlementBillId = row.id
        this.FKJLMark = true
      }
    },
    // 点击一键开票
    allInvoiceFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].auditStatus != 3 && selectData[0].auditStatus != '0') { // 审核通过或者不审核才能操作
          this.$alert('审核通过或不审核的账单才能操作', '系统提示')
          return
        }
        if (selectData[0].invoicingStates == '2' || selectData[0].invoicingStates == '3') {
          this.$alert('只能选择未开票或部分开票的数据', '系统提示')
          return
        }
        this.$set(this.kaiPiaoFrom, 'invoiceAmount', selectData[0].noInvoiceAmount)
        this.$set(this.kaiPiaoFrom, 'settlementBillId', selectData[0].id)
        this.$set(this.kaiPiaoFrom, 'recordType', 0)
        this.$set(this.kaiPiaoFrom, 'pendingAmount', selectData[0].noInvoiceAmount)
        this.kaiPiaoMark = true
        // 参数 以下都必填
        // settlementBillId 账单表主键id
        // invoiceNo 发票号码
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 开票金额（待开金额）
        // invoiceAmount 开票金额（开票金额）
        // invoiceTime 开票时间 日期类型
      }
    },
    // 点击已开票金额
    getYiKaiPiaoFn (row) {
      if (row.invoicingStates == '0') {
        this.$alert('只能选择已开票或部分开票的数据', '系统提示')
      } else {
        this.kaiPiaoJL.settlementBillId = row.id
        this.KPJLMark = true
      }
    },
    // 点击撤销收款
    chexiaoShouKuan () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        if (selectData[0].auditStatus != 3 && selectData[0].auditStatus != '0') { // 审核通过或者不审核才能操作
          this.$alert('审核通过或不审核的账单才能操作', '系统提示')
          return
        }
        if (selectData[0].settlementStates == '0' || selectData[0].settlementStates == '3') {
          this.$alert('只能选择已付款或者部分付款的数据', '系统提示')
        } else {
          this.fuKuanJL.settlementBillId = selectData[0].id
          this.FKJLMark = true
        }
      }
    },
    // 点击撤销开票
    chexiaoKaiPiao () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        if (selectData[0].auditStatus != 3 && selectData[0].auditStatus != '0') { // 审核通过或者不审核才能操作
          this.$alert('审核通过或不审核的账单才能操作', '系统提示')
          return
        }
        if (selectData[0].invoicingStates == '0' || selectData[0].invoicingStates == '3') {
          this.$alert('只能选择已开票或者部分开票的数据', '系统提示')
        } else {
          this.kaiPiaoJL.settlementBillId = selectData[0].id
          this.KPJLMark = true
        }
      }
    },
    // 导出
    daochuFN (row) {
      this.$set(row, 'isDisable', false)
      let from = {
        yfSettlementBillId: row.id
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportOutsideYfWayList',
        from,
        '应付明细列表'
      )
      this.$set(row, 'isDisable', true)
      setTimeout(() => {
        this.$set(row, 'isDisable', false) // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  },
  activated () {
    this.$route.meta.isBack = false
    this.getList()
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}

/deep/.setclass{
  background: #ffc7c1;
}
//  .formItemBox{
//     /deep/.el-form-item{
//       width: 24%;
//     }
//   }
</style>
